// extracted by mini-css-extract-plugin
export var chevronIcon = "_9a-2";
export var teamName = "_9a-1";
export var teamSwitcherButton = "_9a-0";